import { add as addDuration, format, sub } from 'date-fns';

import type { DateRange } from '@zen/DesignSystem/types';

import type { Duration } from '../types';
import { compareDate } from './comparing';
import { parseDate } from './parsing';
import { getToday } from './utils';

export const subtract = (date: string, duration: Duration): string => format(sub(parseDate(date), duration), 'yyyy-MM-dd');

export const add = (date: string, duration: Duration): string => format(addDuration(parseDate(date), duration), 'yyyy-MM-dd');

export const getDateRange = <T>(daysInDuration: number, startDate: string = getToday(), value?: T): DateRange<T> => {
  const endDate = add(startDate, { days: daysInDuration });
  const isEndDateBeforeStartDate = compareDate(endDate).isBefore(startDate);

  const baseRange = {
    startDate: isEndDateBeforeStartDate ? endDate : startDate,
    endDate: isEndDateBeforeStartDate ? startDate : endDate
  };

  return value === undefined ? baseRange : { ...baseRange, value };
};
